import { useMutation } from '@apollo/client'
import React from 'react'
import { toast } from 'sonner'

import { ADD_EXTERNAL_TRACKING_SOURCE } from '../../data/mutations/tracking'
import { SHIPMENT_TRACKING_SOURCES } from '../../data/queries/tracking'
import { AddTrackingInput } from './add-tracking-input'

interface AddTrackingLinkProps {
  shipmentID: string
}

/*
 * This component is used to add a third-party tracking link to a shipment.
 */
export const AddTrackingLink = ({ shipmentID }: AddTrackingLinkProps) => {
  // Mutation to add the new tracking URL
  const [addExternalTrackingSource] = useMutation(ADD_EXTERNAL_TRACKING_SOURCE, {
    onCompleted: () => {
      toast.success('Tracking link added successfully.')
    },
    onError: (error) => {
      toast.error(error.message || 'Something went wrong.')
    },
    refetchQueries: [SHIPMENT_TRACKING_SOURCES, 'TrackingSources']
  })

  return (
    <AddTrackingInput
      shipmentID={shipmentID}
      inputName="url"
      buttonText="Add a third-party tracking link"
      placeholder="Enter tracking URL"
      mutation={addExternalTrackingSource}
      validationPattern={/^https?:\/\/.+/}
      validationMessage="Please enter a valid URL"
      successMessage="Tracking link added successfully"
      errorMessage="Failed to add tracking link"
    />
  )
}
